module.exports = __webpack_public_path__ + "RU.png?c95849bdd2927696c89ed1a3a03b8ef1";